import { createContext, useContext } from 'react';
const WorkspaceContext = createContext(null);
export const WorkspaceProvider = WorkspaceContext.Provider;
export function useWorkspace() {
    const value = useContext(WorkspaceContext);
    if (!value) {
        throw new Error('useWorkspace must be used inside WorkspaceProvider');
    }
    return value;
}
